export enum EventKey {
  beforeunload = 'beforeunload',
  click = 'click',
  load = 'load',
  message = 'message',
  popout = 'popout',
  resize = 'resize',
  storage = 'storage',
  visibilityChange = 'visibilityChange',
}

export enum LocalStorageKey {
  activeChannelId = 'activeChannelId',
  // session keys
  authKey = 'authKey',
  sessionExpired = 'sessionExpired',
  // watchlist keys
  fetchWatchlists = 'fetchWatchlists',
  // Popout keys
  fingerprint = 'fingerprint',
  popoutCachedState = 'popoutCachedState',
  popoutDataTransfer = 'popoutDataTransfer',
  popoutUpdate = 'popoutUpdate',
  recentAutocompleteQuotes = 'recentAutocompleteQuotes',
}
